import { CLASSROOM_MODULE_LIVE_UPDATED_MATERIAL } from '../actions';

const liveUpdatedMaterial = (dispatch, payload) =>
  dispatch({
    type: CLASSROOM_MODULE_LIVE_UPDATED_MATERIAL,
    payload,
  });

export default (dispatch) => (material) =>
  liveUpdatedMaterial(dispatch, material);
